/* eslint-disable no-restricted-imports */
import { ReactElement, ReactNode } from 'react'
import {
  FieldArray as FinalFormFieldArray,
  FieldArrayProps as FinalFormFieldArrayProps,
  FieldArrayRenderProps as FinalFormFieldArrayRenderProps,
  useFieldArray as finalFormUseFieldArray,
  UseFieldArrayConfig,
} from 'react-final-form-arrays'

export interface FieldArrayRenderProps<FieldValue = any, _T = any>
  extends Omit<FinalFormFieldArrayRenderProps, 'fields'> {
  fields: Omit<FinalFormFieldArrayRenderProps['fields'], 'value'> & {
    value: FieldValue[]
    /** Existe em runtime, mas está fora da tipagem do react-final-form-arrays. */
    update: (index: number, value: FieldValue) => void
  }
}

export type FieldArrayProps<FieldValue = any> = Omit<FinalFormFieldArrayProps, 'render' | 'children' | 'component'> & {
  render?: (props: FieldArrayRenderProps<FieldValue>) => ReactNode
  children?: (props: FieldArrayRenderProps<FieldValue>) => ReactNode
}

// TODO(#33977): remover o cast quando o projeto migrar para React 18+, cujo JSX aceita componente retornando ReactNode
export const FieldArray = (FinalFormFieldArray as unknown) as <FieldValue = any>(
  props: FieldArrayProps<FieldValue>
) => ReactElement | null

export function useFieldArray<FieldValue = any>(
  name: string,
  config?: UseFieldArrayConfig
): FieldArrayRenderProps<FieldValue> {
  return (finalFormUseFieldArray(name, config) as unknown) as FieldArrayRenderProps<FieldValue>
}
